import { property } from "lodash";
import React, { useEffect, useState } from "react";
import { Button, Grid, TextField, Typography } from "@mui/material";

import { useLevels } from "@dyl/systems/LevelsManager";
import DataGridDyl from "@dyl/components/DataGridDyl";
import getConfigs from "@dyl/apiClients/backendApi/getConfigs";
import updateConfig from "@dyl/apiClients/backendApi/updateConfig";


const onKeyUp = (row) => async(event) => {
    if (event.code === 'Enter') { await onClick(row)(); }
}

const onClick = (row) => async() => {
    const { level_id, config_id, key } = row;
    const element = document.getElementById(`tf-${config_id}-${key}`);
    await updateConfig(level_id, config_id, { [key]: element.value });
}

const columns = [
    { headerName: 'Key', field: 'key', flex: 4 },
    { headerName: 'Value', field: 'value', flex: 2, renderCell: function({ value, row }) {
            return <TextField
                id={`tf-${row.config_id}-${row.key}`}
                fullWidth
                variant='filled'
                defaultValue={value}
                onKeyUp={onKeyUp(row)}
            />
        }
    },
    { headerName: 'Action', flex: 2, renderCell: function({ row }) {
            return <Button onClick={onClick(row)}> Update </Button>
        }
    }
];

export default function Config() {
    const { globalLevel } = useLevels();
    const [configs, setConfigs] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(async() => {
        setLoading(true);
        const data = await getConfigs(globalLevel.level_id);
        setLoading(false);
        setConfigs(data);
    }, []);

    return (
        <Grid container spacing={10}>
            {!!configs && Object.entries(configs).map( ([config_id, params]) => {
                let kv = params.map(p => {
                    const [key, value] = Object.entries(p)[0];
                    return { key, value, config_id, level_id: globalLevel.level_id };
                });
                return (<Grid item md={12}>
                    <Typography variant={"h4"} style={{ margin: '10px', paddingTop: '20px' }} >{config_id}:</Typography>
                    <DataGridDyl disableSelectionOnClick getRowId={property('key')} rows={kv} columns={columns} loading={loading}/>
                </Grid>)
            })}

        </Grid>
    )
}